// extracted by css-extract-rspack-plugin
export default {"sharedAvatar":"src-wab-client-components-dashboard-dashboard-module__sharedAvatar-RxHzTz"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sharedAvatar\":\"src-wab-client-components-dashboard-dashboard-module__sharedAvatar-RxHzTz\"}";
        // 1793541993693
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  